import React from "react";
import { Form } from "react-bootstrap";
import "../style/style-register.css";
import { useState } from "react";
import axios from "../axios/axios";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const [msgText, setMsgText] = useState("");
  const [linkText, setLinkText] = useState("");

  const navigate = useNavigate();

  const setAuthToken = (token) => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  };

  const login = (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("email", email);
    form.append("password", password);

    axios
      .post("/login", form, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        const { user } = response.data;
        const { access_token } = response.data;

        setAuthToken(access_token);
        Cookies.set("auth_token", access_token);
        Cookies.set("auth_user", JSON.stringify(user));

        setError(null);
        if (response.data.user.role == 1) {
          navigate(`${process.env.PUBLIC_URL}/ll`);
        } else {
          // Récupérer l'URL de redirection
          const redirectUrl =
            Cookies.get("redirect_url") || `${process.env.PUBLIC_URL}/profile`;
          // Supprimer l'URL de redirection des cookies
          Cookies.remove("redirect_url");
          // Rediriger vers l'URL de redirection
          navigate(redirectUrl);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          if (err.response.data.message === "L'e-mail n'existe pas.") {
            setError("notEixt");
            setMsgText("Cette adresse email n'est pas enregistrée.");
            setLinkText("Cliquez ici pour s'inscrire");
          } else if (err.response.data.message === "Mot de passe incorrect.") {
            setError("Mot de passe incorrect.");
          }
        } else {
          setError("Une erreur s'est produite lors de l'authentification.");
        }
      });
  };

  return (
    <div id="section" className="signup">
      <div className="container card">
        <div className="row bg-light">
          <div className="col-sm-12">
            <center>
              <h3 style={{ fontWeight: "900", padding: "10px" }}>
                S'Authentifier
              </h3>
              <p style={{ color: "black", fontWeight: "600" }}>
                {" "}
                Vous n'avez pas encore de compte ?
                <Link
                  to={`${process.env.PUBLIC_URL}/inscrire`}
                  style={{ color: "red", textDecoration: "none" }}
                >
                  {" "}
                  Inscrivez vous
                </Link>
              </p>
            </center>
          </div>
        </div>

        <div className="signup-content">
          <Form id="signup-form" className="signup-form" onSubmit={login}>
            <div className="row">
              {/* {error != null && error == 'notEixt' ?
                            <div className="alert alert-danger col-sm-12 text-center">
                                <p> 
                                    {msgText}  11
                                    <Link to={`${process.env.PUBLIC_URL}/inscrire`} style={{color:'black', fontWeight:'bold'}}>
                                         {linkText}
                                    </Link>
                                </p>
                            </div>
                            : error != null && error != 'notEixt' ?
                            <div className="alert alert-danger col-sm-12 text-center">{error} 22 </div>
                            : null   } */}

              {error != null &&
                (error === "notEixt" ? (
                  <div className="alert alert-danger col-sm-12 text-center">
                    <p>
                      {msgText}
                      <Link
                        to={`${process.env.PUBLIC_URL}/inscrire`}
                        style={{ color: "black", fontWeight: "bold" }}
                      >
                        {linkText}
                      </Link>
                    </p>
                  </div>
                ) : (
                  <div className="alert alert-danger col-sm-12 text-center">
                    {error}
                  </div>
                ))}

              <div className="form-group col-sm-12">
                <label>EMAIL</label>
                <input
                  type="email"
                  required
                  className="form-input"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError(null);
                  }}
                />
              </div>

              <div className="form-group col-sm-12">
                <label>Password</label>
                <input
                  type="password"
                  required
                  className="form-input"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError(null);
                  }}
                />
              </div>

              <div className="form-group col-sm-12">
                <p style={{ fontWeight: "800" }}>
                  <Link
                    to={`${process.env.PUBLIC_URL}/reset-password`}
                    style={{ color: "red" }}
                  >
                    Mot de passe oublié ?
                  </Link>
                </p>
              </div>

              <div className="form-group col-sm-12 ">
                <button
                  type="submit"
                  className="btn "
                  style={{
                    borderRadius: "25px",
                    float: "right",
                    fontWeight: "900",
                    background: "#047104",
                    color: "#fff",
                  }}
                >
                  S'Authentifier
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
